import type { TagTypeName } from "@/api/db/schema/tag";

export const forumCategoryLabels: Record<TagTypeName, string> = {
  General: "Genel",
  Powerlifting: "Powerlifting",
  Bodybuilding: "Vücut geliştirme",
  Nutrition: "Beslenme",
  Recovery: "Toparlanma",
  Mental: "Zihinsel hazırlık",
  Equipment: "Ekipman",
  Technique: "Hareket tekniği",
  Community: "Topluluk",
  Events: "Yarışmalar ve etkinlikler",
  Other: "Diğer",
};
